
define('text!TescoMobile_Checkout/template/product/view/upgrade.html',[],function () { return '<!-- ko if: !isLoggedIn() || isEligibleForPhoneUpgrade() --><div id="upgrade-button" class="upgrade-button" afterrender="setUpgradeBtnLabel"><a class="action secondary upgrade" data-bind="click: isExistingCustomer"><span data-bind="text: upgradeBtnLabel"></span></a></div><!-- /ko -->';});

